import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { useStoreActions, useStoreState } from 'easy-peasy';

import FAQ from './FAQ';
import Embed from './Embed';

const FAQWrapper = styled.div`
  background: #fff;
  border-radius: 2px;
  box-shadow: 2px 0 8px 2px rgba(0, 0, 0, 0.18);
  padding: 15px;
  max-width: 670px;
  margin: 30px auto 0 auto;
  position: relative;
  max-height: 80vh;
  overflow: auto;
`;

const Background = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0%;
  background: rgba(0, 0, 0, 0.25);
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 200;
`;

const DisableBodyScroll = createGlobalStyle`
  body {
    overflow: hidden !important;
  }
`;

export default function Infobox() {
  const infoboxContent = useStoreState((state) => state.info.infoboxContent);
  const setInfoboxContent = useStoreActions(
    (state) => state.info.setInfoboxContent
  );

  if (!['faq', 'embed'].includes(infoboxContent)) {
    return null;
  }

  return (
    <>
      <Background>
        <DisableBodyScroll />
        <FAQWrapper>
          {infoboxContent === 'faq' ? (
            <FAQ setInfoboxContent={setInfoboxContent} />
          ) : (
            <Embed setInfoboxContent={setInfoboxContent} />
          )}
        </FAQWrapper>
      </Background>
    </>
  );
}
